/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cal_OverlineInputs */

const en_cp_cal_overline = /** @type {(inputs: Cp_Cal_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CALENDAR`)
};

const id_cp_cal_overline = /** @type {(inputs: Cp_Cal_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KALENDER`)
};

/**
* | output |
* | --- |
* | "CALENDAR" |
*
* @param {Cp_Cal_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cal_overline = /** @type {((inputs?: Cp_Cal_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cal_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cal_overline(inputs)
	return en_cp_cal_overline(inputs)
});